<template>
<div>
  <aside class="main-content">
    <div class="content">
      <div class="nest-contents">
        <p>処理中です。しばらくお待ちください。</p>
        <p>{{ success }}</p>
        <p class="err-message">{{ error }}</p>
      </div>
    </div>
  </aside>
</div>
</template>

<script>
export default {
  data() {
    return {
      success: "",
      error: ""
    }
  },

  mounted() {
    this.authenticate()
  },

  methods: {
    authenticate() {
      if (this.$firebase.auth().isSignInWithEmailLink(window.location.href)) {
        let email = this.$cookie.get("email")
        if (!email) {
          email = window.prompt("再度メールアドレスを入力してください。")
        }

        this.$firebase.auth().signInWithEmailLink(email, window.location.href)
          .then((result) => {
            this.$store.dispatch("setToken", result.user.ra).then(() => {
              let params = new URLSearchParams()
              params.append("email", email)
              
              this.$http.post("/input_login", params).then((res) => {
                this.$store.dispatch("setUser", res.data)
                this.$router.push({ name: "transports" })
              })
            })

            this.success = "認証されました。"
          })
          .catch(() => {
            this.error = "エラーが発生しました。操作をやり直してください。"
          })
      } else {
        this.error = "リンクが無効です。送信されたメールからリンクを開き直してください。"
      }
    }
  }
}
</script>